import { ReactElement, useMemo, useReducer } from "react";

import { Block, Dispatch, Image, State } from "../types";
import { reducer } from "./reducer";

type ChildrenArgs = Readonly<{
  dispatch: Dispatch;
  state: State;
}>;
type Props = Readonly<{
  children: (args: ChildrenArgs) => ReactElement;
  initialBlocks: ReadonlyArray<Block>;
  readonly: boolean;
  images: ReadonlyArray<Image>;
}>;

export const StateManager = ({ children, initialBlocks, readonly, images }: Props) => {
  const initialState = useMemo((): State => {

  const canvasPageStart: number = 0;
  const canvasPageEnd: number = images.length;
  const blocks: { [blockId: string]: Block } = {};
  for (const block of initialBlocks) {
    blocks[block.id] = block;
  }
  const activeBlockOrder = GetActiveBlockOrder(initialBlocks, canvasPageStart, canvasPageEnd);
  const activeBlocks = GetActiveBlocks(initialBlocks, canvasPageStart, canvasPageEnd);
    return {
      blockOrder: Object.keys(blocks),
      blocks,
      readonly,
      scrollToPageBlock: undefined,
      scrollToTextBlock: undefined,
      selectedBlockId: undefined,
      showReadingOrder: true,
      canvasPageStart,
      canvasPageEnd,
      activeBlockOrder,
      activeBlocks,
      pageSize: 100000,
      currentPage: 0
    };
  }, [initialBlocks]);
  const [state, dispatch] = useReducer(reducer, initialState);
  const args = useMemo((): ChildrenArgs => ({ dispatch, state }), [dispatch, state]);
  return children(args);
};

const GetActiveBlockOrder = (initialBlocks: readonly Block[], canvasPageStart: number, canvasPageEnd: number): Array<string> => {
  const blockOrder: Array<string> = [];
  for (const block of initialBlocks) {
    if (block.page >= canvasPageStart && block.page < canvasPageEnd) {
      blockOrder.push(block.id); 
    }
  }
  return blockOrder;
};

const GetActiveBlocks = (initialBlocks: readonly Block[], canvasPageStart: number, canvasPageEnd: number): { [blockId: string]: Block } => {
  const blocks: { [blockId: string]: Block } = {};
  for (const block of initialBlocks) {
    if (block.page >= canvasPageStart && block.page < canvasPageEnd) {
      blocks[block.id] = {
        ...block,
      };
    }
  }
  return blocks;
};
